import { z } from 'zod';

import {
  createEntityAdapterSchema,
  findDuplicateIds,
  findDuplicateNames,
} from '../../base';
import { VariableSchema } from './variables.schema';

export const VariablesSchema = z
  .object({
    variables: createEntityAdapterSchema(VariableSchema),
  })
  .superRefine((data, ctx) => {
    const variables = Object.values(data.variables.entities);
    const duplicateVariableNames = findDuplicateNames(variables);
    const duplicateVariableIds = findDuplicateIds(variables);

    for (const duplicate of duplicateVariableNames) {
      ctx.addIssue({
        path: ['variables', 'entities', duplicate.id, 'name'],
        code: z.ZodIssueCode.custom,
        message: 'Duplicate name',
      });
    }

    for (const duplicate of duplicateVariableIds) {
      ctx.addIssue({
        path: ['variables', 'entities', duplicate.id, 'id'],
        code: z.ZodIssueCode.custom,
        message: 'Duplicate ID',
      });
    }
  });
